import _cloneDeep from 'lodash/cloneDeep';
import Utils from 'services/utils';

const LABELS_ADDED_KEY = 'labels_added';
const LABELS_REMOVED_KEY = 'labels_removed';

export default class ThingDetailLabelsController {
    /** @ngInject */
    constructor(EventEmitter, $timeout) {
        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
    }

    $onChanges(changes) {
        if (changes.labels) {
            this.originalLabels = _cloneDeep(changes.labels.currentValue);
        }
    }

    onLabelsAdded({ label }) {
        let preUpdatePromise = this.$timeout(Utils.noop, 0).then(() => label);

        if (!label.id) {
            preUpdatePromise = this.preUpdate(
                this.eventEmitter({
                    data: label
                })
            );
        }

        preUpdatePromise.then((item) => {
            this.onUpdate(
                this.eventEmitter({
                    patch: {
                        [LABELS_ADDED_KEY]: [item.id]
                    },
                    data: {
                        labels: [...this.originalLabels, item]
                    }
                })
            );
        });
    }

    onLabelsRemoved({ label }) {
        this.onUpdate(
            this.eventEmitter({
                patch: {
                    [LABELS_REMOVED_KEY]: [label.id]
                },
                data: {
                    labels: this.originalLabels.filter(item => item.id !== label.id)
                }
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-labels/thing-details-labels.controller.js